
import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, defaultActualizarEstatus, defaultConsultaOficios, defaultDetalleOficio, defaultNuevoOficio, DetalleOficioResponse, GuardarDestinatariosProps, ActualizarOficioParams, NuevoOficioParams, NuevoOficioResponse, ConsultaOficiosParams, ConsultaOficiosResponse, DescargarOficiosParams } from '../../interfaces/tribunal/OficioInterface';

export const NuevoOficio = ( params: NuevoOficioParams ) => {

    return new Promise<NuevoOficioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Oficio/NuevoOficio', params, token)
            .then( ({ data } : { data : NuevoOficioResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultNuevoOficio, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const DetalleOficio = ( Id: string ) => {

    return new Promise<DetalleOficioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Oficio/DetalleOficio/${ Id }`, token)
            .then( ({ data } : { data : DetalleOficioResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultDetalleOficio, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const GuardarOficio = ( params: ActualizarOficioParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Oficio/GuardarOficio/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const GuardarDestinatarios = ( params: GuardarDestinatariosProps ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Oficio/GuardarDestinatarios/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const ActualizarEstatusOficio = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Oficio/ActualizarEstatus/', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultActualizarEstatus, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const ConsultarOficios = async ( params: ConsultaOficiosParams ) => {

    return new Promise<ConsultaOficiosResponse>((resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '{}' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/Oficio/ConsultarOficios/', params, token)
            .then(({ data }: { data: ConsultaOficiosResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve( { ...defaultConsultaOficios } );
            });

        }

    });

};

export const DescargarOficios = async ( params: DescargarOficiosParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/Oficio/DescargarOficios', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

};
